import React, { Component } from 'react';
import {
  withRouter,
} from 'react-router-dom';
import './Unauthenticated.scss';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import {  removeRecentCasesCount } from 'Utils/localStorageUtils.js';

class LayoutUnauthenticated extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log('[LayoutUnauthenticated] Component mounted - GP Auth handles authentication');
    removeRecentCasesCount();
  }

  render() {
    return (
      <div className="page-wrapper">
        <BVLoader20 />
      </div>
    );
  }
}

export default withRouter(LayoutUnauthenticated);
